import React from 'react';
import ArrowForwardIosRoundedIcon from '@material-ui/icons/ArrowForwardIosRounded';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';

export const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <button
      className={`${className} custom-arrow`}
      style={{
        ...style,
        display: 'block',
        width: 'fit-content',
        height: 'fit-content',
        right: '-80px',
      }}
      onClick={onClick}
    >
      <ArrowForwardIosRoundedIcon style={{ fontSize: '45px', color: 'white' }} />
    </button>
  );
}

export const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <button
      className={`${className} custom-arrow`}
      style={{
        ...style,
        display: 'block',
        width: 'fit-content',
        height: 'fit-content',
        left: '-80px',
      }}
      onClick={onClick}
    >
      <ArrowBackIosRoundedIcon style={{ fontSize: '45px', color: 'white' }} />
    </button>
  );
}
